import { CheckoutConfig } from '../../models/config/checkout-config.interface';
import { mockCheckoutCardConfig } from '../checkout-card/checkout-card-config.mock';
import { mockCheckoutDirectDebitConfig } from '../checkout-direct-debit/checkout-direct-debit-config.mock';
import { mockMentionMeConfig } from '../mention-me/mention-me-config.mock';
import { mockCheckoutFeatures } from './checkout-features.mock';

export const mockCheckoutConfig: CheckoutConfig = {
  applianceCareNumberOfWorkingDaysNotification: 14,
  basketApi: 'basketApi',
  boilerCareNumberOfWorkingDaysNotification: 10,
  card: mockCheckoutCardConfig,
  commonApi: 'commonApi',
  directDebit: mockCheckoutDirectDebitConfig,
  features: mockCheckoutFeatures,
  mentionMe: mockMentionMeConfig,
  promotionFirstPaymentTitle: 'Test title',
};
